
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34.976","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.234 1.364a17.49 17.49 0 00-13.5 32.268 1.839 1.839 0 00.543.12c.13.013.305.01.354.01a1.687 1.687 0 001.686-1.686V17.009a5.2 5.2 0 115.2 5.2 1.686 1.686 0 000 3.373 8.568 8.568 0 10-8.568-8.568v12.405a14.1 14.1 0 1114.777.2 1.685 1.685 0 101.725 2.895 17.487 17.487 0 00-2.216-31.147z","fill":"#00b6d4"}}),_c('path',{attrs:{"d":"M20.452 30.711a2.144 2.144 0 102.144 2.145 2.145 2.145 0 00-2.144-2.145z","fill":"#97c619"}})])
          )
        }
      }
    